// extracted by mini-css-extract-plugin
module.exports = {"title":"RelatedProduct_title__3Z-JU"};